import { Modal, ModalProps } from 'modules/common/components/Modal/Modal'
import defaultI18n, { i18n } from 'i18next'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import React, { DependencyList } from 'react'
import { useModal } from 'react-modal-hook'

export type ContentModalProps = Pick<
  ModalProps,
  | 'classNames'
  | 'headerButtonType'
  | 'headerIconButtonVariant'
  | 'headerTitle'
  | 'overlayTransitionType'
  | 'shouldCloseOnEsc'
  | 'shouldCloseOnOverlayClick'
  | 'content'
  | 'footer'
  | 'onBack'
> & {
  onCancel?: () => unknown | Promise<unknown>
  i18n?: i18n
}

// We need a i18n instance to make the <Trans> components work
defaultI18n
  .use(initReactI18next) // bind react-i18next to the instance
  .init()

interface ReactModalProps {
  in: boolean
  enter: any
  exit: any
  onExited: () => void
}

export const useContentModal = (
  {
    onCancel,
    onBack,
    footer,
    content,
    i18n = defaultI18n,
    ...props
  }: ContentModalProps,
  deps: DependencyList = []
) => {
  const [showModal, hideModal] = useModal(
    ({ in: open }: ReactModalProps) => {
      const onClose = async () => {
        if (onCancel) {
          await onCancel()
        }
        hideModal()
      }

      return (
        <Modal
          isOpen={open}
          onClose={onClose}
          onBack={onBack}
          footer={
            footer && <I18nextProvider i18n={i18n}>{footer}</I18nextProvider>
          }
          content={<I18nextProvider i18n={i18n}>{content}</I18nextProvider>}
          hideModal={hideModal}
          {...props}
        />
      )
    },
    [footer, content, ...deps]
  )

  return {
    showModal,
    hideModal,
  }
}
